var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center text-primary-dark pt-5"},[_c('font-awesome-icon',{staticClass:"fa-spin",attrs:{"icon":"spinner"}}),_c('br'),_vm._v(_vm._s(_vm.texto)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }